import { AcademyReadingTimeFragment } from '@cms/graphql/articlePage.generated';

export const formatReadingTime = (
  time: AcademyReadingTimeFragment,
  minutesSingular: string,
  minutesPlural: string,
): string =>
  `${time.min} ${time.max ? `- ${time.max}` : ''} ${
    (time.max || time.min) > 1 ? minutesPlural : minutesSingular
  }`;
